
import { DefaultStyle, SamplesStyle } from "./features/map"
import Hash from './shared/Hash';

export const Config = {

    path: "/product/wrongvri/",

    metricModuleId: "WrongVRI",

    texts: {
        appName: "нарушения ВРИ",
        title: ['Выявляем нецелевое', 'использование недвижимости'],
        subtitle: [],
        textInfos: [
            {
                upper: '',
                title: 'Что это?',
                text: [
                    'Автоматизированное обнаружение нарушений видов разрешенного использования (ВРИ) на большей части территории РФ.',
                    'Найденные нарушения отправляются в ФНС для пересчета налога по повышенной ставке и пополнения муниципального бюджета.',
                    'Точность обнаружения по результатам верификации на территории Самарской области составляет 90-95%.'
                ]
            },
            {
                upper: '',
                title: 'Как работает?',
                text: ['Основывается на технологии "Робот-картограф", соединяющей геоданные и адресные данные более чем из 10 источников, включая данные Единого государственного реестра недвижимости и обнаружении следов "коммерческой деятельности" с налоговой ставкой 1,5% на земельных участках, предоставленных под ИЖС, личное подсобное хозяйство и иные виды использования, для которых применяется пониженная ставка 0,1-0,3% от кадастровой стоимости.']
            },
            {
                upper: '',
                title: 'Как использовать?',
                text: [
                    '1. Проверить Ваш регион или муниципалитет, посмотреть статистику по найденным нарушениям и оценке дополнительных налогов, образец (пример) реальных данных по городу Самаре.',
                    '2. Оставить свои контакты и получить бесплатный фрагмент карты по Вашему городу или региону и бесплатную презентацию с техническими подробностями по его обработке.',
                    '3. Заказать полный набор данных и/или сервис.'
                ]
            }
        ],
        footer: {
            text: ["Всего по России 116136 нарушений", "на 3.2 млрд рублей в год"]
        },
        report: {
            button: "Отчет",
            header: "Получить отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Спасибо, мы с вами свяжемся в ближайшее время!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_160/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 1) && (p.properties_.count > 0) ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_160/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 2) && (p.properties_.count > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_160/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 3) && (p.properties_.count > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_147/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                return SamplesStyle;
            },
            turned: false,
            afterTurned: (view) => {
                view.setCenter([5587958, 7016790]); //Самара
                //view.setCenter([5481772, 7518731]); //Казань
                view.setZoom(15);
            }
        }
    ],
    featureInfo: {
        properties: [
            { name: 'Количество нарушений', field: "count", unit: "шт" },
            { name: 'Общая площадь', field: "totalSquare", unit: "м²" },
            { name: 'Общая кадастровая стоимость', field: "totalCost", divisor: 1000000, unit: "млн.руб." },
            { name: 'Оценка дополнительного налога', field: "extraTax", divisor: 1000000, round: 3, unit: "млн.руб/год" },

            { name: 'Площадь', field: "Square", unit: "м²" },
            { name: 'Кадастровая стоимость', field: "Cost", divisor: 1000000, round: 3, unit: "млн.руб." },
            { name: 'Дополнительный налог', field: (p) => { return p.Cost ? (p.Cost * (1.5 - 0.3) * 0.01 / 1000).toFixed(1) : null; }, unit: "тыс.руб/год" },
            { name: 'Оценочная группа', field: (p) => { return p.EvaluationGroup; }, longText: true },
            { name: 'ВРИ по документам', field: (p) => { return p.AllowedDoc; }, longText: true },
            {
                name: 'Организации по адресу',
                field: (p) => {
                    if (p.orgs) {
                        let orgs = JSON.parse(p.orgs) || [];
                        return orgs.join(', ');
                    }
                },
                longText: true
            }
        ],
        territoryNameFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return properties.Address ? properties.Address :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }
    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.ID || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


